import { render, staticRenderFns } from "./RegisterUser.vue?vue&type=template&id=19b2d4ac&scoped=true"
import script from "./RegisterUser.vue?vue&type=script&lang=js"
export * from "./RegisterUser.vue?vue&type=script&lang=js"
import style0 from "./RegisterUser.vue?vue&type=style&index=0&id=19b2d4ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b2d4ac",
  null
  
)

export default component.exports